export default __webpack_public_path__ + "static/media/sports (8).00b9f2f7.jpg";